import { Box, SxProps } from '@mui/material';
import useScreenSize from '../../../hooks/useScreenSize';

export function GreenerLogo({
  logoColor = 'white',
  textColor = 'white',
  fullWidth = false,
  sx = {},
  ...props
}: {
  logoColor?: string;
  textColor?: string;
  fullWidth?: boolean;
  sx?: SxProps;
}) {
  const { isWindowBigger } = useScreenSize();

  return (
    <Box
      {...props}
      sx={{
        display: 'flex',
        ...sx,
      }}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="28"
        height="100%"
        viewBox="0 0 28 28"
        fill="none"
        style={{ display: 'block', flexShrink: 0 }}
      >
        <path d="M15.5556 19.7037H12.4445V28H15.5556V19.7037Z" fill={logoColor} />
        <path d="M9.8 18.1628L5.65186 25.3478L8.34642 26.9033L12.4946 19.7184L9.8 18.1628Z" fill={logoColor} />
        <path d="M8.28333 15.5063L1.09839 19.6544L2.65394 22.349L9.83888 18.2009L8.28333 15.5063Z" fill={logoColor} />
        <path d="M8.2963 12.4445H0V15.5556H8.2963V12.4445Z" fill={logoColor} />
        <path d="M2.65224 5.65442L1.09668 8.34899L8.28162 12.4971L9.83717 9.80257L2.65224 5.65442Z" fill={logoColor} />
        <path d="M8.34642 1.09839L5.65186 2.65394L9.8 9.83888L12.4946 8.28333L8.34642 1.09839Z" fill={logoColor} />
        <path d="M15.5556 0H12.4445V8.2963H15.5556V0Z" fill={logoColor} />
        <path d="M19.651 1.09924L15.5029 8.28418L18.1974 9.83974L22.3456 2.6548L19.651 1.09924Z" fill={logoColor} />
        <path d="M28 12.4445H15.5555V15.5556H28V12.4445Z" fill={logoColor} />
        <path d="M19.7193 15.5054L18.1637 18.2L25.3486 22.3481L26.9042 19.6536L19.7193 15.5054Z" fill={logoColor} />
        <path d="M18.2 18.1611L15.5054 19.7167L19.6536 26.9016L22.3481 25.3461L18.2 18.1611Z" fill={logoColor} />
      </svg>

      {(fullWidth || isWindowBigger('md')) && (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="80"
          height="100%"
          viewBox="28 0 86 28"
          fill="none"
          style={{ display: 'block', flexShrink: 0 }}
        >
          <path
            d="M103.151 19.7054V8.29626H109.133C111.463 8.29626 113.158 9.84491 113.158 11.9147C113.158 13.3656 112.327 14.5228 110.941 15.0932L113.435 19.7054H110.323L108.074 15.6143H105.988V19.7054H103.151ZM105.987 13.3484H108.676C109.572 13.3484 110.209 12.7616 110.209 11.9466C110.209 11.1317 109.572 10.5777 108.676 10.5777H105.987V13.3484Z"
            fill={textColor}
          />
          <path
            d="M92.8364 19.7054V8.29626H101.948V10.6106H95.6727V12.7944H101.068V15.1087H95.6727V17.3902H101.948V19.7045H92.8364V19.7054Z"
            fill={textColor}
          />
          <path
            d="M80.1664 19.7054V8.29626H82.7417L88.5604 15.4026H88.658V8.29626H91.3958V19.7054H88.8205L83.0019 12.5991H82.9042V19.7054H80.1664Z"
            fill={textColor}
          />
          <path
            d="M69.8522 19.7054V8.29626H78.9626V10.6106H72.6877V12.7944H78.082V15.1087H72.6877V17.3902H78.9626V19.7045H69.8522V19.7054Z"
            fill={textColor}
          />
          <path
            d="M59.538 19.7054V8.29626H68.6484V10.6106H62.3735V12.7944H67.7678V15.1087H62.3735V17.3902H68.6484V19.7045H59.538V19.7054Z"
            fill={textColor}
          />
          <path
            d="M48.3475 19.7054V8.29626H54.3295C56.6602 8.29626 58.3549 9.84491 58.3549 11.9147C58.3549 13.3656 57.5236 14.5228 56.1383 15.0932L58.6324 19.7054H55.5195L53.27 15.6143H51.1838V19.7054H48.3475ZM51.1838 13.3484H53.8732C54.7694 13.3484 55.4054 12.7616 55.4054 11.9466C55.4054 11.1317 54.7694 10.5777 53.8732 10.5777H51.1838V13.3484Z"
            fill={textColor}
          />
          <path
            d="M40.2198 19.9146C36.7319 19.9146 34.2222 17.4205 34.2222 14.0147C34.2222 10.6089 36.8952 8.08197 40.8887 8.08197C44.132 8.08197 46.658 9.71185 46.9354 12.0426H43.839C43.4968 11.0972 42.3561 10.4939 40.9051 10.4939C38.672 10.4939 37.1562 11.8628 37.1562 14.0147C37.1562 16.0032 38.4922 17.5026 40.6605 17.5026C42.2904 17.5026 43.6109 16.6876 43.9687 15.4328H40.9042V13.2818H46.9346V19.7037H44.8156L44.571 18.1551H44.4733C43.5115 19.2794 41.9473 19.9154 40.2198 19.9154V19.9146Z"
            fill={textColor}
          />
        </svg>
      )}
    </Box>
  );
}
